export default "__VITE_ASSET__BmbRHKA8__"